/** Waits for asynchronously expanded navigator children before falling back to an ancestor. */
export function waitForNavigatorRow(root: HTMLElement, selector: string, timeoutMs = 1000): Promise<Element | undefined> {
  const findRow = () => {
    const row = root.isConnected ? root.querySelector(selector) : null;
    return row?.getClientRects().length ? row : undefined;
  };
  const existing = findRow();
  if (existing || !root.isConnected) return Promise.resolve(existing);
  return new Promise((resolve) => {
    const finish = (row?: Element) => {
      observer.disconnect();
      clearTimeout(timeout);
      resolve(row);
    };
    const observer = new MutationObserver(() => {
      const row = findRow();
      if (row || !root.isConnected) finish(row);
    });
    const timeout = setTimeout(() => finish(findRow()), timeoutMs);
    observer.observe(root, {childList: true, subtree: true, attributes: true});
    // Cover a row mounted between the initial query and observer registration.
    const row = findRow();
    if (row) finish(row);
  });
}
